import { useSyncExternalStore } from 'react';
import type { Nivel, Tema } from '../tokens/tokens';

export type FaixaTela = 'celular' | 'tablet' | 'desktop' | 'amplo';

function observarAtributo(nome: string) {
  return (aviso: () => void) => {
    const o = new MutationObserver(aviso);
    o.observe(document.documentElement, { attributes: true, attributeFilter: [nome] });
    return () => o.disconnect();
  };
}

function observarMidia(consulta: string) {
  return (aviso: () => void) => {
    const m = window.matchMedia(consulta);
    m.addEventListener('change', aviso);
    return () => m.removeEventListener('change', aviso);
  };
}

const assinarNivel = observarAtributo('data-nivel');
const assinarTema = observarAtributo('data-tema');
const assinarEscuro = observarMidia('(prefers-color-scheme: dark)');
const assinarMovimento = observarMidia('(prefers-reduced-motion: reduce)');

/** Nível visual ativo, lido do <html data-nivel> (quem decide é o roteador, 07 §0.1). */
export function useNivel(): Nivel {
  return useSyncExternalStore(assinarNivel, () => (document.documentElement.dataset.nivel === 'work' ? 'work' : 'experience'), () => 'experience');
}

/** Tema efetivo: o escolhido ou o do sistema. */
export function useTema(): Tema {
  const escolhido = useSyncExternalStore(assinarTema, () => document.documentElement.dataset.tema ?? '', () => '');
  const sistemaEscuro = useSyncExternalStore(assinarEscuro, () => window.matchMedia('(prefers-color-scheme: dark)').matches, () => true);
  return escolhido === 'claro' ? 'claro' : escolhido === 'escuro' ? 'escuro' : sistemaEscuro ? 'escuro' : 'claro';
}

export function useMovimentoReduzido(): boolean {
  const sistema = useSyncExternalStore(assinarMovimento, () => window.matchMedia('(prefers-reduced-motion: reduce)').matches, () => false);
  return sistema || document.documentElement.dataset.movimento === 'reduzido';
}

export function faixaDaLargura(largura: number): FaixaTela {
  return largura < 768 ? 'celular' : largura < 1024 ? 'tablet' : largura < 1440 ? 'desktop' : 'amplo';
}

function assinarLargura(aviso: () => void) {
  window.addEventListener('resize', aviso);
  return () => window.removeEventListener('resize', aviso);
}

export function useFaixa(): FaixaTela {
  return useSyncExternalStore(assinarLargura, () => faixaDaLargura(window.innerWidth), () => 'desktop');
}
